/**
 * VIVO Code By Mike C.
 * This file is loaded in the theme.liquid file
 * <script src="{{ 'custom.js' | asset_url }}" defer="defer"></script>
 * 
 * 
 * This event listener listens for a variant change event on the product, and then recalculates
 * the "Saved $" amount that corresponds to the variants compare_at_price.
 * 
 * This event also relies on in the theme.liquid file
 * <script type="application/json" id="product-data">
 *   {{ product | json }}
 * </script>
 * 
 */
document.addEventListener('DOMContentLoaded', function() {
    const productDataElement = document.getElementById('product-data');
    if (!productDataElement) {
      console.log('❌ Product data not found');
      return;
    }

    const product = JSON.parse(productDataElement.textContent);
    onLoadSetBadge();
   
    const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');

    variantSelectors.forEach(function(selector) {
      selector.addEventListener('change', function(e) {
        const variantId = parseInt(e.target.value);
        const variant = product.variants.find(v => v.id === variantId);

        if (variant) {
          updateSaveBadge(variant);
        }
      });
    });

    function updateSaveBadge(variant) {
      const productSection = document.querySelector('[id*="main-product"]');
      const badgeContainer = productSection ? productSection.querySelector('.badge--onsale') : null;

      if (!badgeContainer) return;

      if (!variant.compare_at_price || variant.compare_at_price <= variant.price) {
        badgeContainer.style.display = 'none';
        return;
      }

      const savedAmount = variant.compare_at_price - variant.price;
      const saveType = badgeContainer.dataset.saveType;

      let badgeText = '';
      if (saveType === 'dollar') {
        badgeText = 'Save $' + (savedAmount / 100).toFixed(2);
      } else {
        const savedPercent = Math.round((savedAmount / variant.compare_at_price) * 100);
        badgeText = 'Save ' + savedPercent + '%';
      }

      badgeContainer.textContent = badgeText;
      badgeContainer.style.display = 'flex';
    }

    function onLoadSetBadge() {
        //ok we need to get the current window url and parse data and set the variant to what is on the url
        const queryString = window.location.search //?_pos=1&_psq=DESK-E3CTB&_ss=e&_v=1.0&variant=39800069488739
        const params = new URLSearchParams(queryString);
        const currVariant = params.get("variant")
        if(currVariant){
          const variant = product.variants.find(v => v.id === currVariant);
          if (variant) {
            updateSaveBadge(variant);
          }
        }
    }
  });

/** End Custom VIVO Code */
